import React from 'react';

export default function SidebarPanelIcon() {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="16"
      viewBox="0 0 24 24"
      width="16"
    >
      <rect height="18" rx="2" stroke="currentColor" strokeWidth="2" width="18" x="3" y="3" />
      <path d="M9 3v18" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
    </svg>
  );
}
